// @flow

// Instructs analytics.js to use the name `ga`.
window.GoogleAnalyticsObject = 'ga';
// Creates an initial ga() function.
// The queued commands will be executed once analytics.js loads.
window.ga =
  window.ga ||
  function() {
    (window.ga.q = window.ga.q || []).push(arguments);
  };
// alias global for brevity
const ga = window.ga;
// Sets the time (as an integer) this tag was executed.
// Used for timing hits.
ga.l = +new Date();
// Creates a default tracker with automatic cookie domain configuration.
ga('create', 'UA-237328-21', {
  cookieName: 'prga', // re-use dashboard ga cookie
  cookieDomain: 'auto',
});

const Analytics = {
  pageview(page: string) {
    ga('send', {
      hitType: 'pageview',
      page,
    });
  },

  event(props: {
    eventCategory: string,
    eventAction: string,
    eventLabel?: string,
    eventValue?: number,
  }) {
    ga('send', {
      hitType: 'event',
      ...props,
    });
  },

  timing(props: {
    timingCategory: string,
    timingVar: string,
    timingValue: number,
  }) {
    ga('send', {
      hitType: 'timing',
      ...props,
    });
  },

  exception(props: { exDescription: string, exFatal: boolean }) {
    ga('send', {
      hitType: 'exception',
      ...props,
    });
  },

  setPageTitle(title: string) {
    ga('set', 'page', {
      title,
    });
  },

  setUserId(userId: number) {
    ga('set', 'userId', userId);
  },
};

export default Analytics;



// WEBPACK FOOTER //
// ./src/lib/analytics.js